import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import ModalWindow from '@common/components/modal/modal-window';
import ModalContent from '@common/components/modal/modal-content';
import {
  AnniversaryEvent,
  BirthdayEvent,
  EEventTypes,
} from '@modules/calendar/types/events';
import Profile from '@common/components/profile';
import { useHistory, useParams } from 'react-router';

type CelebrationModelProps = {
  selectedCelebration: BirthdayEvent | AnniversaryEvent;
  show: boolean;
  onClose: () => void;
};

const CelebrationModel = memo(
  ({ selectedCelebration, show, onClose }: CelebrationModelProps) => {
    const { t } = useTranslation();
    const history = useHistory();
    const { networkId } = useParams<{ networkId: string }>();

    const handleHide = () => {
      onClose();
    };

    const handleProfileClick = useCallback(
      (user: any) => {
        if (networkId) {
          history.push(`/networks/${networkId}/users/${user.id}/about`);
        } else {
          history.push(`/admin/users/${user.id}/about`);
        }
      },
      [history, networkId]
    );
    return (
      <ModalWindow show={show} onHide={handleHide}>
        <ModalContent
          title={
            selectedCelebration.type === EEventTypes.BIRTHDAY
              ? t('social:birthdays')
              : t('social:anniversaries')
          }
          hideFooter
          onHide={handleHide}
        >
          <div className="BirthdaysList ">
            {selectedCelebration?.users?.map((user: any) => (
              <div
                className="tw-flex tw-items-center tw-justify-between tw-mx-[20px] tw-py-[12px]"
                key={user.id}
              >
                <div
                  onClick={() => handleProfileClick(user)}
                  className="tw-cursor-pointer"
                >
                  <Profile size={40} user={user}>
                    {selectedCelebration.type === EEventTypes.BIRTHDAY ? (
                      null
                    ) : (
                      <p className="tw-text-gray-custom-430 tw-m-0 tw-pt-1">
                        {t('social:anniversary_in_years', { count: user.year })}
                      </p>
                    )}
                  </Profile>
                </div>
              </div>
            ))}
          </div>
        </ModalContent>
      </ModalWindow>
    );
  }
);

export default CelebrationModel;
